import { IS_PRODUCTION } from 'shared/config/env';
import { cratChain, wagmiConfig } from 'shared/config/wagmi';
import { getContract } from 'viem';

import { TAP2MINE_REFERRAL_ABI } from '../abi';

const address = {
  testnet: '0xdd079f47Ac182fC379e3f5046e30e59f5Fb7b93b',
  mainnet: '0x5045E1FA60EBf6283dFc57DBD303bB9E2BC410F3',
} as const;

export const tap2mineReferralContract = getContract({
  abi: TAP2MINE_REFERRAL_ABI,
  address: IS_PRODUCTION ? address.mainnet : address.testnet,
  client: wagmiConfig.getClient({
    chainId: cratChain.id,
  }),
});
